<template>
  <el-dialog
    class="program-details-dialog"
    v-model="dialogVisible"
    title="节目详情"
    width="1000"
    center
    :show-close="true"
  >
    <div class="program-details-dialog-content">
      <!-- 基本信息 -->
      <el-descriptions
        class="margin-top"
        title="基本信息"
        :column="3"
        size="default"
        border
      >
        <template #extra>
          <el-button
            type="primary"
            @click="openEditProgramDialog()"
            >修改节目配置</el-button
          >
        </template>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">创建时间</div>
          </template>
          {{ currentProgramm.createTime }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">节目ID</div>
          </template>
          {{ currentProgramm.id }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">Remarks</div>
          </template>
          <el-tag size="small">School</el-tag>
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">节目内容</div>
          </template>
          {{ currentProgramm.broadcastContent || "暂无节目内容" }}
        </el-descriptions-item>
      </el-descriptions>
      <!-- 背景图 -->
      <el-descriptions
        class="background-box"
        style="margin-top: 20px"
        :column="3"
        size="default"
        border
      >
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">背景图</div>
          </template>
          <el-image
            class="background-image"
            :src="currentProgramm.backgroundUrl"
            :preview-src-list="[currentProgramm.backgroundUrl]"
          >
            <template #error>
              <div class="image-slot">
                <img src="@/assets/images/no-picture.png" />
                <div class="no-image-text">暂无背景图</div>
              </div>
            </template>
          </el-image>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, defineExpose } from "vue";

const editCreateProgramDialog = ref(null);

const emit = defineEmits(["openEditProgramDialog"]);

const dialogVisible = ref(false); // 对话框是否显示
const currentProgramm = ref({}); // 当前节目
const previewSrc = ref(""); // 预览视频地址
const previewVideo = ref(null); // 预览视频元素

// 关闭对话框
const handleClose = () => {
  dialogVisible.value = false;
};

// 打开对话框
const openDialog = (programm) => {
  console.log(programm, "programm");
  dialogVisible.value = true;
  currentProgramm.value = programm;
  previewSrc.value = programm.videoMakeMediaUrl;
};

// 打开编辑节目弹窗
const openEditProgramDialog = () => {
  emit("openEditProgramDialog", currentProgramm.value);
  dialogVisible.value = false;
};

// 格式化秒数为时间
const formatSecondsToTime = (seconds) => {
  let milliseconds = seconds * 1000; // 转换为毫秒
  let hours = Math.floor(milliseconds / (1000 * 60 * 60));
  let minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
  let remainingSeconds = Math.floor((milliseconds % (1000 * 60)) / 1000);
  let millisecondsRemainder = milliseconds % 1000;

  // 确保小时、分钟、秒和毫秒始终显示两位数（对于小时，可能需要显示一位或两位）
  hours = String(hours).padStart(2, "0");
  minutes = String(minutes).padStart(2, "0");
  remainingSeconds = String(remainingSeconds).padStart(2, "0");
  millisecondsRemainder = String(millisecondsRemainder).substring(0, 3).padStart(3, "0");

  return `${hours}:${minutes}:${remainingSeconds}.${millisecondsRemainder}`;
};

defineExpose({
  openDialog,
});
</script>
<style lang="scss" scoped>
.program-details-dialog {
  .program-details-dialog-content {
    max-height: 600px;
    overflow: auto;
  }
  .background-box {
    ::v-deep .el-descriptions__label {
      text-align: center;
      width: 100px !important;
    }
    ::v-deep .el-descriptions__content {
      text-align: center;
    }
    /* 背景图-无背景图 */
    .image-slot {
      display: flex; /* 使用flex布局 */
      justify-content: center; /* 水平居中 */
      align-items: center; /* 垂直居中 */
      flex-direction: column;
      width: 100%;
      height: 100%;
      img {
        background-size: cover;
        background-position: center;
        width: 200px;
        height: 200px;
        max-width: 100%; /* 确保图片不会超过容器宽度 */
        max-height: 100%;
      }
      .no-image-text {
        font-weight: 600;
        color: white; /* 文本颜色，根据背景调整 */
        font-size: 14px; /* 文本大小，根据需要调整 */
      }
    }
  }
}
</style>
